module.exports = __webpack_public_path__ + "static/media/fantasy.8763dd9c.svg";